import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from "react-router-dom";
import { Alert, Button, Form, FormGroup, Input, InputGroup, InputGroupAddon, Label } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Patients from '../store/Patients';
import * as StudySites from '../store/StudySites';
import * as utility from '../data/Utility';

const createPatientType = {
    code: "code",
    enrollDate: "enrollDate",
    enrollDateTime: "enrollDateTime",
    procedureDate: "procedureDate",
    withdrawalDateTime: "withdrawalDateTime",
    enrollTime: "enrollTime"
}

class CreatePatientInternal extends React.Component {
    constructor(props) {
        super(props);

        var create = true;
        var editing = true;
        var patientId = "";
        var studySite = null;
        if (props.create != null) {
            create = props.create;
        }
        if (props.editing != null) {
            editing = props.editing;
        }
        if (props.patientId != null) {
            patientId = props.patientId;
        }
        if (props.studySite != null) {
            studySite = props.studySite;
        }
        const timeZone = utility.getTimeZone();
        this.state = {
            create: create,
            editing: editing,
            patientId: patientId,
            studySite: studySite,
            timeZone: timeZone,
			timeZoneOffsetMinutes: -utility.getTimeZoneOffset(),
        };

        this.getFormGroup = this.getFormGroup.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleStudySiteClear = this.handleStudySiteClear.bind(this);
        this.handleValue = this.handleValue.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize();
    }

    componentWillUnmount() {
        this.props.studySitesDispatch.set(null);
    }

    getFormGroup(type, value, onChangeFunc) {
        var firstInput = null;
        var inputId = "";
        var label = "";
        var optional = false;
        var secondInput = null;

        if (value == null) {
            value = "";
        }


        switch (type) {
            case createPatientType.code:
                inputId = "codeInput";
                label = "Code";
                break;
            case createPatientType.enrollDateTime:
                inputId = "enrollDateInput";
                const enrollDate = utility.formatInputDate(value);
                const enrollTime = utility.formatInputTime(value);
                firstInput = this.getInput(inputId, "date", createPatientType.enrollDate, enrollDate);
                secondInput = this.getInput("enrollTimeInput", "time", createPatientType.enrollTime, enrollTime);
                label = `Enroll DateTime (${this.state.timeZone})`;
                optional = true;
                break;

            case createPatientType.procedureDate:
                inputId = "procedureDateInput";
                label = "Procedure Date";

				let strProcedureDate = value;
				if ( ! strProcedureDate || ! moment(strProcedureDate).isValid() ) {
					strProcedureDate = null;
				}

				firstInput = <DatePicker
								selected={strProcedureDate && new Date(strProcedureDate)}
								onChange={(datestr) => onChangeFunc(createPatientType.procedureDate,datestr)}
								timeInputLabel="Time:"
								dateFormat="MM/dd/yyyy"
								placeholderText="MM/DD/YYYY"
								peekNextMonth
								showMonthDropdown
								showYearDropdown
								dropdownMode="select"
								closeOnScroll={true}
								disabled={!this.state.editing}
							/>;
				break;

            case createPatientType.withdrawalDateTime:
                inputId = "withdrawalDateTimeInput";
                label = "Withdrawal Date";

				let strWithdrawalDateTime = value;
				if ( ! strWithdrawalDateTime || ! moment(strWithdrawalDateTime).isValid() ) {
					strWithdrawalDateTime = null;
				}

				firstInput = <DatePicker
								selected={strWithdrawalDateTime && new Date(moment(strWithdrawalDateTime).format())}
								onChange={(datestr) => onChangeFunc(createPatientType.withdrawalDateTime,datestr)}
								timeInputLabel="Time:"
								dateFormat="MM/dd/yyyy"
								placeholderText="MM/DD/YYYY"
								peekNextMonth
								showMonthDropdown
								showYearDropdown
								dropdownMode="select"
								closeOnScroll={true}
								disabled={!this.state.editing}
							/>;
				break;

            default:
                break;
        }

        if (firstInput == null) {
            firstInput = this.getInput(inputId, "text", type, value);
        }

        return (
            <FormGroup>
                <Label for={inputId}>{label}{optional && <i><small> - Optional</small></i>}</Label>
                {firstInput}
                {secondInput}
            </FormGroup>
        );
    }

    getInput(inputId, inputType, valueType, value) {
        return (
            <Input className="input" disabled={!this.state.editing} id={inputId} onChange={(e) => this.handleValue(valueType, e.target.value)} onKeyDown={this.handleKeyDown} type={inputType} value={value} />
        );
    }

    handleCancel() {
        if (this.state.create) {
            this.props.history.push(paths.home);
        }
        else {
            this.initialize();
            if (this.state.editing) {
                this.setState({
                    editing: false
                });
            }
        }
    }

    handleEdit() {
        this.setState({
            editing: true
        });
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSave();
        }
    }

    handleSave() {
        const patient = this.props.patientsState.patient;
        var studySite = this.state.studySite;
        const studySiteProps = this.props.studySitesState.studySite;

        if (studySite == null &&
            studySiteProps != null) {
            studySite = studySiteProps;
        }

        if (patient.code === "" ||
            studySite == null) {
            this.setState({
                error: true
            });
        }
        else {
            this.setState({
                error: false
            });

            if (this.state.create) {
                this.props.patientsDispatch.create(studySite.id);
                this.props.history.push(paths.home);
            }
            else {
                (async () => {
                    await this.props.patientsDispatch.update(studySite.id);
                })().then(() => {
                    this.props.history.push(paths.managePatients);
                });
            }
        }
    }

    handleStudySiteClear() {
        this.setState({
            studySite: null
        });
    }

    handleValue(type, value) {
        const patient = this.props.patientsState.patient;
        switch (type) {
            case createPatientType.code:
                patient.code = value;
                break;

            case createPatientType.procedureDate:
				// console.log(`handleValue(${type}, ${value})  patient.procedureDate = ${patient.procedureDate}  value = ${value}   new val = ${moment(value).format("MM/DD/YYYY")} `);
                patient.procedureDate = moment(value).format("MM/DD/YYYY");
				break;

            case createPatientType.withdrawalDateTime:
                patient.withdrawalDateTime = moment(value).format("MM/DD/YYYY");
				break;

            case createPatientType.enrollDate:
                patient.enrollDateTime = utility.getDateTimeFromInputDate(value, patient.enrollDateTime);
                break;
            case createPatientType.enrollTime:
                patient.enrollDateTime = utility.getDateTimeFromInputTime(value, patient.enrollDateTime);
                break;
            default:
                break;
        }
        this.props.patientsDispatch.set(patient);
    }

    initialize() {
        if (this.state.studySite == null) {
            if (this.state.create) {
                const patient = JSON.parse(JSON.stringify(Patients.emptyPatient));
                this.props.patientsDispatch.set(patient);
            }
            else {
                (async () => {
                    await this.props.patientsDispatch.get(this.state.patientId);
                })().then(() => {
                    const patient = this.props.patientsState.patient;
                    if (patient != null &&
                        patient.studySite != null) {
                        this.props.studySitesDispatch.get(patient.studySite.id);
                    }
                });
            }
        }
    }

    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const cancel = "Cancel";
        var code = null;
        var displayEditLink = false;
        const editing = this.state.editing;
        var enrollDateTime = null;
        var procedureDate = null;
        var withdrawalDateTime = null;
        const linkTitle = "Link";
        const patient = this.props.patientsState.patient;
        var patientCode = "";
        const save = "Save";
        var studySite = this.state.studySite;
        const studySiteInputId = "studySiteInput";
        var studySiteName = "";
        const studySiteProps = this.props.studySitesState.studySite;
        var title = "Create Patient";

        if (!this.state.create) {
            if (editing) {
                title = "Edit Patient";
            }
            else {
                displayEditLink = true;
                title = "Patient";
            }
        }

        if (patient != null) {
            patientCode = patient.code;
            code = this.getFormGroup(createPatientType.code, patientCode, null);
            enrollDateTime = this.getFormGroup(createPatientType.enrollDateTime, patient.enrollDateTime, null);
            procedureDate = this.getFormGroup(createPatientType.procedureDate, patient.procedureDate, this.handleValue );
            withdrawalDateTime = this.getFormGroup(createPatientType.withdrawalDateTime, patient.withdrawalDateTime, this.handleValue );
        }

        if (studySite == null &&
            studySiteProps != null) {
            studySite = studySiteProps;
        }
        studySiteName = utility.formatStudySiteName(studySite);
        const displayStudySite = studySiteName !== "";

        const isServiceEvent = studySite && studySite.study && studySite.study.isServiceEvent;
        if (isServiceEvent === true) {
			displayEditLink = false;
		}

        return (
            <Form>
                <h1>{title} {displayEditLink && <Button className="button-link" onClick={this.handleEdit}>(Edit)</Button>}</h1>
                {this.state.error && <Alert color="warning">Missing or incorrect fields.</Alert>}
                {code}
                {enrollDateTime}
                {procedureDate}
                {withdrawalDateTime}
                <div>
                    <Label for={studySiteInputId}>Study/Site</Label>
                    {displayStudySite && (
                        <InputGroup>
                            <Input className="input" disabled id={studySiteInputId} type="text" value={studySiteName} />
                            <InputGroupAddon addonType="append">
                                <Button aria-label="Close" className="button" close={true} disabled={!editing} onClick={this.handleStudySiteClear} outline>
                                    <span aria-hidden="true">&times;</span>
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                    )}
                    <br />
                    <Button className="button" disabled={!editing} tag={Link} title={linkTitle} to={{ pathname: paths.selectStudySite, state: { createPatient: this.state.create, patientCode: patientCode } }}>{linkTitle}</Button>
                </div>
                {editing && (
                    <div className="button-gap">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>
                    </div>
                )}
            </Form>
        );
    }
}

const CreatePatientConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        patientsState: state.patients,
        studySitesState: state.studySites
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        patientsDispatch: bindActionCreators(Patients.actionCreators, dispatch),
        studySitesDispatch: bindActionCreators(StudySites.actionCreators, dispatch)
    })
)(CreatePatientInternal));

export default class CreatePatient extends React.Component {
    render() {
        var create = true;
        var editing = true;
        var patientId = "";
        var studySite = null;

        const propsState = this.props.location.state;
        if (propsState != null) {
            if (propsState.create != null) {
                create = propsState.create;
            }
            if (propsState.editing != null) {
                editing = propsState.editing;
            }
            if (propsState.patientId != null) {
                patientId = propsState.patientId;
            }
            if (propsState.studySite != null) {
                studySite = propsState.studySite;
            }
        }

        return (
            <ErrorBoundary>
                <CreatePatientConnect create={create} editing={editing} patientId={patientId} studySite={studySite} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreatePatient.js